import React, { useState } from 'react'
import './index.sass';
import SelecIconButton from '../common/Button/SelectIconButton'



export default function AccountType({ vIcon, vActiveIcon, vText, vDescription, cIcon, cActiveIcon, cText, cDescription, handleClick }) {
    const [vIsActive, setVIsActive] = useState(false);
    const [cIsActive, setCIsActive] = useState(false);

    const vHandleButtonClick = () => {
        setVIsActive(true);
        setCIsActive(false);
        handleClick(0);

    }
    const cHandleButtonClick = () => {
        setCIsActive(true);
        setVIsActive(false);
        handleClick(1);
    }
    return (
        <div className="lover-account-type">
            <div className="lover-account-btn-wrapper">
                <SelecIconButton
                    isActive={vIsActive}
                    icon={vIcon}
                    activeIcon={vActiveIcon}
                    text={vText}
                    description={vDescription}
                    handleClick={vHandleButtonClick}
                />
            </div>
            <div className="lover-account-btn-wrapper">


                <SelecIconButton
                    isActive={cIsActive}
                    icon={cIcon}
                    activeIcon={cActiveIcon}
                    text={cText}
                    description={cDescription}
                    handleClick={cHandleButtonClick}
                />
            </div>

        </div>
    )
}
